const styles = {
  buttonWrapper: {
    background: 'none',
    justifyContent: 'flex-start',
    ':hover': {
      background: 'none',
    },
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },
  button: {
    padding: '0px',
  },
  icon: {
    color: 'rgb(23, 232, 128)',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/NewProjectButton/NewProjectButton.styles.js